import React, { Fragment } from 'react'
import styles from './container.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import Spinner from 'pobble-components/dist/spinner'

const Container = ({ classes, children, className, pending }) => (
  <div className={classNames(classes.container, className)}>
    <Fragment>
      {children}
      {pending && (
        <div className={classes.pendingOverlay}>
          <Spinner />
        </div>
      )}
    </Fragment>
  </div>
)

export default injectSheet(styles)(Container)
